import { createLogic } from 'redux-logic'
import { SYNC_SECRETS } from '@app/constants/secrets'
import { deps } from '@app/constants/channels'
import { PROGRAM_OPTIONS_TIMEOUT } from '@app/constants/timeouts'
import { setInitialOptions } from '@app/actions/programOptions'
import PO from '@app/lib/ProgramOptions'
import programOptionChannel from '@app/api/programOptions'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const fetchSecretsLogic = createLogic({
  type: SYNC_SECRETS,
  cancelType: API_REQUEST_CANCEL,
  warnTimeout: PROGRAM_OPTIONS_TIMEOUT,

  process(_, dispatch, done) {
    programOptionChannel({
      request: (channel) => {
        const numbers = [PO.PRODUCT_SERIAL_1333]
        channel.perform('get_program_options', { numbers, ...deps })
        dispatch(apiRequestSent(SYNC_SECRETS))
      },
      response: (data, isFinished) => {
        const { programOptions, error } = data
        if (error && error.msg) {
          dispatch(apiRequestFailed(error.msg, error.code))
        } else {
          dispatch(setInitialOptions(programOptions))
          if (isFinished) {
            dispatch(apiRequestDone(SYNC_SECRETS))
          }
        }
        if (isFinished) {
          done()
        }
      },
    })
  },
})

export default fetchSecretsLogic
